import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../forms/Button";

const NoColoringBook = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="w-full py-16 flex flex-col items-center justify-center gap-8 min-h-[calc(100vh-360px)]">
        <div className="flex flex-col items-center justify-center gap-6 max-w-sm">
          <div className="bg-md-pink-light-1 w-32 aspect-square flex items-center justify-center rounded-full text-5xl text-md-pink">
            <i className="fa-light fa-fw fa-image" />
          </div>
          <div className="space-y-2 text-center">
            <div className="text-3xl font-semibold text-md-dark">
              No coloring books found
            </div>
            <div
              className="text-xl text-slate-500"
              dangerouslySetInnerHTML={{
                __html:
                  "Create your first coloring book by clicking the\n'New Coloring Book' button.".replace(
                    /\n/g,
                    "<br />"
                  ),
              }}
            />
          </div>
        </div>
        <div className="flex items-center justify-center">
          <Button
            buttonLabel="Create Coloring Book"
            buttonIcon="fa-regular fa-plus"
            buttonIconPosition="left"
            buttonFunction={() => navigate("/create")}
            buttonClasses="!px-5 !rounded-lg"
          />
        </div>
      </div>
    </>
  );
};

export default NoColoringBook;
